
(() => {
  const getThreshold = () => {
    const bar = document.querySelector('[data-delivery-progress]');
    const value = parseInt(bar?.dataset.thresholdPence || '', 10);
    return Number.isFinite(value) && value > 0 ? value : 5000;
  };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function updateDeliveryBar() {
    try {
      const cart = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'}}).then(r => r.json());
      const bar = document.querySelector('[data-delivery-progress]');
      if (!bar) return;

      const total = Number(cart.items_subtotal_price || cart.total_price || 0);
      const visible = Number(cart.item_count || 0) > 0;
      bar.classList.toggle('is-visible', visible);
      if (!visible) return;

      const threshold = getThreshold();
      const remaining = Math.max(0, threshold-total);
      const percent = Math.max(0,Math.min(100,(total/threshold)*100));
      const fill=bar.querySelector('[data-delivery-progress-fill]');
      const text=bar.querySelector('[data-delivery-progress-text]');
      if(fill) fill.style.width=`${percent}%`;
      if(text){
        text.textContent = remaining <= 0
          ? 'Free delivery unlocked ✓'
          : `Spend £${(remaining/100).toFixed(2)} more for free delivery`;
      }

      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    } catch (_) {}
  }

  document.addEventListener('DOMContentLoaded', updateDeliveryBar);
  document.addEventListener('click', e => {
    if (e.target.closest('[data-echo-add], [data-ajax-add], .echo-home-search__add, button[name="add"]')) {
      setTimeout(updateDeliveryBar, 650);
      setTimeout(updateDeliveryBar, 1400);
    }
  });
  window.addEventListener('pageshow', updateDeliveryBar);
})();
